import React from 'react';
import { Outlet } from 'react-router-dom';

const TermLayout = () => {
  return (
    <>
    <Outlet />
  </>
  )
}

export default TermLayout